import React, { useState } from 'react';
import { Avatar, Box, Tab, Tabs, TextField, Typography, Button, InputAdornment, FormControl, InputLabel, OutlinedInput, IconButton } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { AvatarImg, scannerImg } from '../../../assets/images';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { EditIcon, EditWithUnderscroreIcon, GoogleIcon, LinkdinIcon, MicrosoftIcon } from '../../../assets/icons';
import SecurityLinkdinIcon from '../../../assets/icons/securityLinkdinIcon';
import EditIconModal from '../../modals/EditIcon';

const Settings = () => {
    interface TabPanelProps {
        children?: React.ReactNode;
        index: number;
        value: number;
    }

    const [showPassword, setShowPassword] = React.useState(false);
    const [isEnabled, setIsEnabled] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleDialogOpen = () => {
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleConfirm = () => {
        console.log('Confirmed!');
        setDialogOpen(false);
    };

    const CustomTabPanel = (props: TabPanelProps) => {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
            </div>
        );
    };

    const a11yProps = (index: number) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    };

    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleEnableTFA = () => {
        setIsEnabled(true);
    };

    const handleDisableTFA = () => {
        setIsEnabled(false);
    };



    return (
        <Box>
            <Box mb={{ xs: "34px", sm: '20px', xl: "28px" }}>
                <Typography color="#333333" fontSize="24px" mb="15px" fontWeight="500">
                    Account Settings
                </Typography>
                <Typography>Update your account information</Typography>
            </Box>

            <Box sx={{ width: '100%' }} className='settings-module-listing'>
                <Box sx={{ borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} variant="scrollable"
                        scrollButtons="auto" allowScrollButtonsMobile aria-label="basic tabs example" >
                        <Tab label="Profile Information" {...a11yProps(0)} sx={{ textTransform: 'capitalize' }} />
                        <Tab label="Change Password" {...a11yProps(1)} sx={{ textTransform: 'capitalize' }} />
                        <Tab label="Sign In & Security" {...a11yProps(2)} sx={{ textTransform: 'capitalize' }} />
                        <Tab label="User Domain" {...a11yProps(3)} sx={{ textTransform: 'capitalize' }} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <Box display="flex" alignItems="center" mb={6}>
                        <Box position="relative" borderRadius="100%" sx={{
                            "&:hover": {
                                "& .upload-overlay": {
                                    display: "flex"
                                }
                            }
                        }}>
                            <Avatar alt="Remy Sharp" src={AvatarImg} sx={{ width: 72, height: 72, border: "1px solid #614EFA" }} />
                            <Box height={"100%"}
                                width={"100%"}
                                position={"absolute"}
                                top={"0"}
                                display="none"
                                alignItems="center"
                                justifyContent="center"
                                borderRadius={"39px"}
                                sx={{ border: "1px solid #FFFFFF", backgroundColor: "rgba(0, 0, 0, 0.60)", cursor: "pointer" }}
                                className="upload-overlay"
                            >
                                <EditWithUnderscroreIcon />
                            </Box>
                        </Box>
                        <Box ml='16px' >
                            <Typography mb='4px' color='#000000' fontSize='18px'>Ryan Lee</Typography>
                            <Typography color='#333' fontSize='16px'>alexaandriana@gmail.com</Typography>
                        </Box>
                    </Box>
                    <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3, xl: 6 }}>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 8 }}>

                            <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }}>
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                    <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>First Name</Typography>
                                    <TextField
                                        variant="outlined"
                                        placeholder='Enter first Name'
                                        value={"Ryan"}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: '8px',
                                                borderColor: '#C7C7C7',
                                            },

                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: '#333333',
                                                border: '1px solid'
                                            },

                                            "& .MuiOutlinedInput-input": {
                                                padding: '14px 16px',
                                                background: '#ffffff',
                                                borderRadius: '8px'
                                            },
                                            "&.MuiInputBase-input::placeholder": {
                                                color: '#333333',
                                                fontSize: '16px',
                                                opacity: '0.8'
                                            },
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                    <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Last Name</Typography>
                                    <TextField
                                        variant="outlined"
                                        placeholder='Enter last Name'
                                        value={"Lee"}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: '8px',
                                                borderColor: '#C7C7C7',
                                            },

                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: '#333333',
                                                border: '1px solid'
                                            },

                                            "& .MuiOutlinedInput-input": {
                                                padding: '14px 16px',
                                                background: '#ffffff',
                                                borderRadius: '8px'
                                            },
                                            "&.MuiInputBase-input::placeholder": {
                                                color: '#333333',
                                                fontSize: '16px',
                                                opacity: '0.8'
                                            },
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                    <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Company</Typography>
                                    <TextField
                                        variant="outlined"
                                        placeholder='Enter Company Name'
                                        value='Spooky Blinders'
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: '8px',
                                                borderColor: '#C7C7C7',
                                            },

                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: '#333333',
                                                border: '1px solid'
                                            },

                                            "& .MuiOutlinedInput-input": {
                                                padding: '14px 16px',
                                                background: '#ffffff',
                                                borderRadius: '8px'
                                            },
                                            "&.MuiInputBase-input::placeholder": {
                                                color: '#333333',
                                                fontSize: '16px',
                                                opacity: '0.8'
                                            },
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                    <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Job Title</Typography>
                                    <TextField
                                        variant="outlined"
                                        placeholder='Enter Job Title'
                                        value={"Event Moderator"}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: '8px',
                                                borderColor: '#C7C7C7',
                                            },

                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: '#333333',
                                                border: '1px solid'
                                            },

                                            "& .MuiOutlinedInput-input": {
                                                padding: '14px 16px',
                                                background: '#ffffff',
                                                borderRadius: '8px'
                                            },
                                            "&.MuiInputBase-input::placeholder": {
                                                color: '#333333',
                                                fontSize: '16px',
                                                opacity: '0.8'
                                            },
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                    <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>User ID</Typography>
                                    <TextField
                                        variant="outlined"
                                        placeholder='Enter User ID'
                                        value='Lee Ryan'
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: '8px',
                                                borderColor: '#C7C7C7',
                                            },

                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: '#333333',
                                                border: '1px solid'
                                            },

                                            "& .MuiOutlinedInput-input": {
                                                padding: '14px 16px',
                                                background: '#ffffff',
                                                borderRadius: '8px'
                                            },
                                            "&.MuiInputBase-input::placeholder": {
                                                color: '#333333',
                                                fontSize: '16px',
                                                opacity: '0.8'
                                            },
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                    <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Phone Number</Typography>
                                    <TextField
                                        variant="outlined"
                                        placeholder='Enter last Name'
                                        value={"+12 3456 7890"}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: '8px',
                                                borderColor: '#C7C7C7',
                                                background: "#ffffff"
                                            },

                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: '#333333',
                                                border: '1px solid'
                                            },

                                            "& .MuiOutlinedInput-input": {
                                                padding: '14px 16px',
                                                background: '#ffffff',
                                                borderRadius: '8px'
                                            },
                                            "&.MuiInputBase-input::placeholder": {
                                                color: '#333333',
                                                fontSize: '16px',
                                                opacity: '0.8'
                                            },
                                        }}
                                        slotProps={{
                                            input: {
                                                startAdornment: <InputAdornment position="start"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z" stroke="#333333" strokeWidth="1.5" strokeMiterlimit="10" />
                                                </svg>
                                                </InputAdornment>,
                                            },
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Email</Typography>
                                    <TextField
                                        variant="outlined"
                                        placeholder='alexaandriana@gmail.com'
                                        value='alexaandriana@gmail.com'
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: '8px',
                                                borderColor: '#C7C7C7',
                                                background: "#ffffff"
                                            },

                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: '#333333',
                                                border: '1px solid'
                                            },

                                            "& .MuiOutlinedInput-input": {
                                                padding: '14px 16px',
                                                background: '#ffffff',
                                                borderRadius: '8px'
                                            },
                                            "&.MuiInputBase-input::placeholder": {
                                                color: '#333333',
                                                fontSize: '16px',
                                                opacity: '0.8'
                                            },
                                        }}
                                        slotProps={{
                                            input: {
                                                startAdornment: <InputAdornment position="start"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z" stroke="#333333" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9" stroke="#333333" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                </InputAdornment>,
                                            },
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Timezone</Typography>
                                    <TextField
                                        variant="outlined"
                                        placeholder='(UTC +5:30)- Chennai, Kolkata, Mumbai'
                                        value='(UTC +5:30)- Chennai, Kolkata, Mumbai'
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: '8px',
                                                borderColor: '#C7C7C7',
                                                background: "#ffffff"
                                            },

                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: '#333333',
                                                border: '1px solid'
                                            },

                                            "& .MuiOutlinedInput-input": {
                                                padding: '14px 16px',
                                                background: '#ffffff',
                                                borderRadius: '8px'
                                            },
                                            "&.MuiInputBase-input::placeholder": {
                                                color: '#333333',
                                                fontSize: '16px',
                                                opacity: '0.8'
                                            },
                                        }}
                                        slotProps={{
                                            input: {
                                                startAdornment: <InputAdornment position="start"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M15 12H16.5V16.25L19.36 17.94L18.61 19.16L15 17V12ZM16 9C16.69 9 17.37 9.1 18 9.29V4.7L15 5.86V9.07C15.33 9 15.66 9 16 9ZM23 16C23 17.8565 22.2625 19.637 20.9497 20.9497C19.637 22.2625 17.8565 23 16 23C13 23 10.4 21.08 9.42 18.4L8 17.9L2.66 19.97L2.5 20C2.36739 20 2.24021 19.9473 2.14645 19.8536C2.05268 19.7598 2 19.6326 2 19.5V4.38C2 4.15 2.15 3.97 2.36 3.9L8 2L14 4.1L19.34 2.03L19.5 2C19.6326 2 19.7598 2.05268 19.8536 2.14645C19.9473 2.24021 20 2.36739 20 2.5V10.25C21.81 11.5 23 13.62 23 16ZM9 16C9 13.21 10.63 10.8 13 9.67V5.87L9 4.47V16.13V16ZM16 11C14.6739 11 13.4021 11.5268 12.4645 12.4645C11.5268 13.4021 11 14.6739 11 16C11 17.3261 11.5268 18.5979 12.4645 19.5355C13.4021 20.4732 14.6739 21 16 21C17.3261 21 18.5979 20.4732 19.5355 19.5355C20.4732 18.5979 21 17.3261 21 16C21 14.6739 20.4732 13.4021 19.5355 12.4645C18.5979 11.5268 17.3261 11 16 11ZM4 5.46V17.31L7 16.15V4.45L4 5.46Z" fill="#333333" />
                                                </svg>
                                                </InputAdornment>,
                                            },
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                            <Button sx={{
                                textTransform: 'capitalize', bgcolor: '#614EFA', color: '#FFFFFF !important', px: '24px', height: '52px', fontSize: "16px", borderRadius: '8px', '&:hover': {
                                    border: 'none !important',
                                    bgcolor: '#331bf1'
                                }, marginTop: "32px", paddingX: "64px"
                            }}>Update</Button>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 4 }} mt={{ xs: 3, lg: '0' }}>
                            <Typography variant="h6" color="#000" fontSize={"18px"} mb={3}>Social Media</Typography>
                            <Box borderRadius={"20px"} border={"1px solid #E8EAF0"} boxShadow={"0px 4px 12px 0px rgba(43, 43, 48, 0.06)"} p={4} bgcolor="#ffffff">
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12, sm: 6, md: 12 }}>
                                    <Typography variant="h6" color="#000" fontSize={"18px"} mb={3}>Social Media</Typography>
                                        <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Facebook</Typography>
                                        <TextField
                                            variant="outlined"
                                            placeholder='www.facebook.com/ryan-lee21'
                                            value={"www.facebook.com/ryan-lee21"}
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: '8px',
                                                    borderColor: '#C7C7C7',
                                                },

                                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: '#333333',
                                                    border: '1px solid'
                                                },

                                                "& .MuiOutlinedInput-input": {
                                                    padding: '14px 16px',
                                                    background: '#ffffff',
                                                    borderRadius: '8px'
                                                },
                                                "&.MuiInputBase-input::placeholder": {
                                                    color: '#333333',
                                                    fontSize: '16px',
                                                    opacity: '0.8'
                                                },
                                            }}
                                            fullWidth
                                        /></Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 12 }}>
                                        <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Youtube</Typography>
                                        <TextField
                                            variant="outlined"
                                            placeholder='https://www.youtube.com/c/easywebinar'
                                            value='https://www.youtube.com/c/easywebinar'
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: '8px',
                                                    borderColor: '#C7C7C7',
                                                },

                                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: '#333333',
                                                    border: '1px solid'
                                                },

                                                "& .MuiOutlinedInput-input": {
                                                    padding: '14px 16px',
                                                    background: '#ffffff',
                                                    borderRadius: '8px'
                                                },
                                                "&.MuiInputBase-input::placeholder": {
                                                    color: '#333333',
                                                    fontSize: '16px',
                                                    opacity: '0.8'
                                                },
                                            }}
                                            fullWidth
                                        /></Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 12 }}>
                                        <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Linkedin</Typography>
                                        <TextField
                                            variant="outlined"
                                            placeholder='www.linkedin.com/company/spookyblinders'
                                            value='www.linkedin.com/company/spookyblinders'
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: '8px',
                                                    borderColor: '#C7C7C7',
                                                },

                                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: '#333333',
                                                    border: '1px solid'
                                                },

                                                "& .MuiOutlinedInput-input": {
                                                    padding: '14px 16px',
                                                    background: '#ffffff',
                                                    borderRadius: '8px'
                                                },
                                                "&.MuiInputBase-input::placeholder": {
                                                    color: '#333333',
                                                    fontSize: '16px',
                                                    opacity: '0.8'
                                                },
                                            }}
                                            fullWidth
                                        /></Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 12 }}>
                                        <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Twitter</Typography>
                                        <TextField
                                            variant="outlined"
                                            placeholder='www.twitter.com/ryanlee'
                                            value='www.twitter.com/ryanlee'
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: '8px',
                                                    borderColor: '#C7C7C7',
                                                },

                                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: '#333333',
                                                    border: '1px solid'
                                                },

                                                "& .MuiOutlinedInput-input": {
                                                    padding: '14px 16px',
                                                    background: '#ffffff',
                                                    borderRadius: '8px'
                                                },
                                                "&.MuiInputBase-input::placeholder": {
                                                    color: '#333333',
                                                    fontSize: '16px',
                                                    opacity: '0.8'
                                                },
                                            }}
                                            fullWidth
                                        /></Grid>
                                </Grid>
                            </Box>
                            <Button sx={{
                                textTransform: 'capitalize', bgcolor: '#614EFA', color: '#FFFFFF !important', px: '24px', height: '52px', fontSize: "16px", borderRadius: '8px', '&:hover': {
                                    border: 'none !important',
                                    bgcolor: '#331bf1'
                                }, marginTop: "32px", paddingX: "64px"
                            }}
                            >Save</Button>
                        </Grid>
                    </Grid>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <Typography variant="body2" color="#333333" mb="20px" maxWidth="530px" lineHeight="171%">Choose a strong password with at least 8 characters, including a mix of uppercase, lowercase, numbers, and symbols for better security</Typography>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 4 }} mt={{ xs: 3, lg: '0' }}>
                        <Box maxWidth={"400px"}>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12 }}>
                                    <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Current Password</Typography>
                                    <TextField
                                        variant="outlined"
                                        // placeholder='https://www.youtube.com/c/easywebinar'
                                        // value={""}
                                        type={showPassword ? 'text' : 'password'}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: '8px',
                                                borderColor: '#C7C7C7',
                                                background: '#ffffff',
                                                paddingRight: '0'
                                            },

                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: '#333333',
                                                border: '1px solid'
                                            },

                                            "& .MuiOutlinedInput-input": {
                                                padding: '14px 16px',
                                                background: '#ffffff',
                                                borderRadius: '8px'
                                            },
                                            "&.MuiInputBase-input::placeholder": {
                                                color: '#333333',
                                                fontSize: '16px',
                                                opacity: '0.8'
                                            },
                                        }}
                                        slotProps={{
                                            input: {
                                                endAdornment: <InputAdornment position="start"><IconButton onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    onMouseUp={handleMouseUpPassword}  >
                                                    {showPassword ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M12.0001 20.27C15.5301 20.27 18.8201 18.19 21.1101 14.59C22.0101 13.18 22.0101 10.81 21.1101 9.39997C18.8201 5.79997 15.5301 3.71997 12.0001 3.71997C8.47009 3.71997 5.18009 5.79997 2.89009 9.39997C1.99009 10.81 1.99009 13.18 2.89009 14.59C5.18009 18.19 8.47009 20.27 12.0001 20.27Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                        : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M14.5299 9.47004L9.46992 14.53C8.81992 13.88 8.41992 12.99 8.41992 12C8.41992 10.02 10.0199 8.42004 11.9999 8.42004C12.9899 8.42004 13.8799 8.82004 14.5299 9.47004Z" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M17.8201 5.76998C16.0701 4.44998 14.0701 3.72998 12.0001 3.72998C8.47009 3.72998 5.18009 5.80998 2.89009 9.40998C1.99009 10.82 1.99009 13.19 2.89009 14.6C3.68009 15.84 4.60009 16.91 5.60009 17.77" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M8.41992 19.5301C9.55992 20.0101 10.7699 20.2701 11.9999 20.2701C15.5299 20.2701 18.8199 18.1901 21.1099 14.5901C22.0099 13.1801 22.0099 10.8101 21.1099 9.40005C20.7799 8.88005 20.4199 8.39005 20.0499 7.93005" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M9.47 14.53L2 22" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M22 2L14.53 9.47" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    }
                                                </IconButton>
                                                </InputAdornment>,
                                                startAdornment: <InputAdornment position="start"><Box display={"flex"} onClick={handleClickShowPassword}
                                                    onMouseDown={() => handleMouseDownPassword}
                                                    onMouseUp={() => handleMouseUpPassword}  >
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6 10V8C6 4.69 7 2 12 2C17 2 18 4.69 18 8V10" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M12 18.5C13.3807 18.5 14.5 17.3807 14.5 16C14.5 14.6193 13.3807 13.5 12 13.5C10.6193 13.5 9.5 14.6193 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M17 22H7C3 22 2 21 2 17V15C2 11 3 10 7 10H17C21 10 22 11 22 15V17C22 21 21 22 17 22Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </Box>
                                                </InputAdornment>
                                            },
                                        }}
                                        fullWidth
                                    /></Grid>
                                <Grid size={{ xs: 12 }}>
                                    <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>New Password</Typography>
                                    <TextField
                                        variant="outlined"
                                        // placeholder='https://www.youtube.com/c/easywebinar'
                                        // value={""}
                                        type={showPassword ? 'text' : 'password'}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: '8px',
                                                borderColor: '#C7C7C7',
                                                background: '#ffffff',
                                                paddingRight: '0'
                                            },

                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: '#333333',
                                                border: '1px solid'
                                            },

                                            "& .MuiOutlinedInput-input": {
                                                padding: '14px 16px',
                                                background: '#ffffff',
                                                borderRadius: '8px'
                                            },
                                            "&.MuiInputBase-input::placeholder": {
                                                color: '#333333',
                                                fontSize: '16px',
                                                opacity: '0.8'
                                            },
                                        }}
                                        slotProps={{
                                            input: {
                                                endAdornment: <InputAdornment position="start"><IconButton onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    onMouseUp={handleMouseUpPassword}  >
                                                    {showPassword ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M12.0001 20.27C15.5301 20.27 18.8201 18.19 21.1101 14.59C22.0101 13.18 22.0101 10.81 21.1101 9.39997C18.8201 5.79997 15.5301 3.71997 12.0001 3.71997C8.47009 3.71997 5.18009 5.79997 2.89009 9.39997C1.99009 10.81 1.99009 13.18 2.89009 14.59C5.18009 18.19 8.47009 20.27 12.0001 20.27Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                        : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M14.5299 9.47004L9.46992 14.53C8.81992 13.88 8.41992 12.99 8.41992 12C8.41992 10.02 10.0199 8.42004 11.9999 8.42004C12.9899 8.42004 13.8799 8.82004 14.5299 9.47004Z" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M17.8201 5.76998C16.0701 4.44998 14.0701 3.72998 12.0001 3.72998C8.47009 3.72998 5.18009 5.80998 2.89009 9.40998C1.99009 10.82 1.99009 13.19 2.89009 14.6C3.68009 15.84 4.60009 16.91 5.60009 17.77" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M8.41992 19.5301C9.55992 20.0101 10.7699 20.2701 11.9999 20.2701C15.5299 20.2701 18.8199 18.1901 21.1099 14.5901C22.0099 13.1801 22.0099 10.8101 21.1099 9.40005C20.7799 8.88005 20.4199 8.39005 20.0499 7.93005" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M9.47 14.53L2 22" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M22 2L14.53 9.47" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    }
                                                </IconButton>
                                                </InputAdornment>,
                                                startAdornment: <InputAdornment position="start"><Box display={"flex"} onClick={handleClickShowPassword}
                                                    onMouseDown={() => handleMouseDownPassword}
                                                    onMouseUp={() => handleMouseUpPassword}  >
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6 10V8C6 4.69 7 2 12 2C17 2 18 4.69 18 8V10" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M12 18.5C13.3807 18.5 14.5 17.3807 14.5 16C14.5 14.6193 13.3807 13.5 12 13.5C10.6193 13.5 9.5 14.6193 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M17 22H7C3 22 2 21 2 17V15C2 11 3 10 7 10H17C21 10 22 11 22 15V17C22 21 21 22 17 22Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </Box>
                                                </InputAdornment>
                                            },
                                        }}
                                        fullWidth
                                    />
                                    <Box display="flex" alignItems="center" justifyContent="space-between" mt="12px">
                                        <Box height="4px" borderRadius="2px" bgcolor={true ? "#E44258" : "#D9D9D9"} width="calc(100%/4 - 6px)"></Box>
                                        <Box height="4px" borderRadius="2px" bgcolor={false ? "#DEA83F" : "#D9D9D9"} width="calc(100%/4 - 6px)"></Box>
                                        <Box height="4px" borderRadius="2px" bgcolor={false ? "#26BF94" : "#D9D9D9"} width="calc(100%/4 - 6px)"></Box>
                                        <Box height="4px" borderRadius="2px" bgcolor={false ? "#26BF94" : "#D9D9D9"} width="calc(100%/4 - 6px)"></Box>
                                    </Box>
                                    <Typography variant="caption" color="#E44258">Easy</Typography>
                                    {/* <Typography variant="caption" color="#DEA83F">Medium</Typography> */}
                                    {/* <Typography variant="caption" color="#26BF94">Hard</Typography> */}
                                    {/* <Typography variant="caption" color="#26BF94">Strong</Typography> */}
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Confirm New Password</Typography>
                                    <TextField
                                        variant="outlined"
                                        // placeholder='https://www.youtube.com/c/easywebinar'
                                        // value={""}
                                        type={showPassword ? 'text' : 'password'}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: '8px',
                                                borderColor: '#C7C7C7',
                                                background: '#ffffff',
                                                paddingRight: '0'
                                            },

                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: '#333333',
                                                border: '1px solid'
                                            },

                                            "& .MuiOutlinedInput-input": {
                                                padding: '14px 16px',
                                                background: '#ffffff',
                                                borderRadius: '8px'
                                            },
                                            "&.MuiInputBase-input::placeholder": {
                                                color: '#333333',
                                                fontSize: '16px',
                                                opacity: '0.8'
                                            },
                                        }}
                                        slotProps={{
                                            input: {
                                                endAdornment: <InputAdornment position="start"><IconButton onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    onMouseUp={handleMouseUpPassword}  >
                                                    {showPassword ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M12.0001 20.27C15.5301 20.27 18.8201 18.19 21.1101 14.59C22.0101 13.18 22.0101 10.81 21.1101 9.39997C18.8201 5.79997 15.5301 3.71997 12.0001 3.71997C8.47009 3.71997 5.18009 5.79997 2.89009 9.39997C1.99009 10.81 1.99009 13.18 2.89009 14.59C5.18009 18.19 8.47009 20.27 12.0001 20.27Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                        : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M14.5299 9.47004L9.46992 14.53C8.81992 13.88 8.41992 12.99 8.41992 12C8.41992 10.02 10.0199 8.42004 11.9999 8.42004C12.9899 8.42004 13.8799 8.82004 14.5299 9.47004Z" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M17.8201 5.76998C16.0701 4.44998 14.0701 3.72998 12.0001 3.72998C8.47009 3.72998 5.18009 5.80998 2.89009 9.40998C1.99009 10.82 1.99009 13.19 2.89009 14.6C3.68009 15.84 4.60009 16.91 5.60009 17.77" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M8.41992 19.5301C9.55992 20.0101 10.7699 20.2701 11.9999 20.2701C15.5299 20.2701 18.8199 18.1901 21.1099 14.5901C22.0099 13.1801 22.0099 10.8101 21.1099 9.40005C20.7799 8.88005 20.4199 8.39005 20.0499 7.93005" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M9.47 14.53L2 22" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M22 2L14.53 9.47" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    }
                                                </IconButton>
                                                </InputAdornment>,
                                                startAdornment: <InputAdornment position="start"><Box display={"flex"} onClick={handleClickShowPassword}
                                                    onMouseDown={() => handleMouseDownPassword}
                                                    onMouseUp={() => handleMouseUpPassword}  >
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6 10V8C6 4.69 7 2 12 2C17 2 18 4.69 18 8V10" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M12 18.5C13.3807 18.5 14.5 17.3807 14.5 16C14.5 14.6193 13.3807 13.5 12 13.5C10.6193 13.5 9.5 14.6193 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M17 22H7C3 22 2 21 2 17V15C2 11 3 10 7 10H17C21 10 22 11 22 15V17C22 21 21 22 17 22Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </Box>
                                                </InputAdornment>
                                            },
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                        <Button sx={{
                            textTransform: 'capitalize', bgcolor: '#614EFA', color: '#FFFFFF !important', px: '24px', height: '52px', fontSize: "16px", borderRadius: '8px', '&:hover': {
                                border: 'none !important',
                                bgcolor: '#331bf1'
                            }, marginTop: "32px", paddingX: "64px"
                        }}
                        >Update</Button>
                    </Grid>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                    <Box>
                        <Box mb="32px">
                            <Box mb="20px">
                                <Typography color="#333333" fontSize="18px" fontWeight="500" mb="4px">Sign-In</Typography>
                                <Typography color="#333333" fontSize="14px">These accounts are currently linked to your account. Manage your Sign-Ins</Typography>
                            </Box>
                            <Box maxWidth="840px" padding="20px" bgcolor="#FFFFFF" borderRadius="12px" sx={{
                                "> :last-child": {
                                    borderBottom: "none",
                                    marginBottom: "0",
                                },
                            }}>
                                <Box display="flex" borderBottom="1px solid #E8EAF0" pb="15px" justifyContent="space-between" alignItems="center" mb="15px" flexWrap="wrap" gap="20px">
                                    <Box display="flex">
                                        <Box border="1px solid #E8EAF0" borderRadius="2px" height="28px" width="28px" display="flex" alignItems="center" justifyContent="center" padding="5px">
                                            <GoogleIcon></GoogleIcon>
                                        </Box>
                                        <Typography color="#000000" fontSize="16px" marginLeft="10px">Google</Typography>
                                    </Box>

                                    <Typography color="#000000" fontSize="16px"> RyanLeeForever@gmail.com</Typography>

                                    <Box display="flex" width={{ xs: "100%", sm: "unset" }} justifyContent={{ xs: "flex-end", sm: "unset" }}><Button variant="contained" disableElevation sx={{ bgcolor: "#E44258 !important", textTransform: "capitalize", borderRadius: "8px", height: "32px" }}>Sign Out</Button></Box>


                                </Box>
                                <Box display="flex" borderBottom="1px solid #E8EAF0" pb="15px" justifyContent="space-between" alignItems="center" mb="15px" flexWrap="wrap" gap="20px">
                                    <Box display="flex">
                                        <Box border="1px solid #E8EAF0" borderRadius="2px" height="28px" width="28px" display="flex" alignItems="center" justifyContent="center" padding="5px">
                                            <MicrosoftIcon></MicrosoftIcon>
                                        </Box>
                                        <Typography color="#000000" fontSize="16px" marginLeft="10px">Microsoft</Typography>
                                    </Box>
                                    <Box display="flex" width={{ xs: "100%", sm: "unset" }} justifyContent={{ xs: "flex-end", sm: "unset" }}><Button variant="outlined" sx={{
                                        textTransform: "capitalize",
                                        borderRadius: "8px",
                                        height: "32px",
                                        px: "21px",
                                        border: "1px solid #E8EAF0",
                                        color: "#2B2B30",
                                        "&:hover": {
                                            backgroundColor: "#614EFA",
                                            color: "#fff"
                                        }
                                    }}>Sign In</Button></Box>


                                </Box>
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb="15px" flexWrap="wrap" gap="20px">
                                    <Box display="flex">
                                        <Box border="1px solid #E8EAF0" borderRadius="2px" height="28px" width="28px" display="flex" alignItems="center" justifyContent="center" padding="5px">
                                            <SecurityLinkdinIcon></SecurityLinkdinIcon>
                                        </Box>
                                        <Typography color="#000000" fontSize="16px" marginLeft="10px">Linkedin</Typography>
                                    </Box>
                                    <Box display="flex" width={{ xs: "100%", sm: "unset" }} justifyContent={{ xs: "flex-end", sm: "unset" }}><Button variant="outlined" sx={{
                                        textTransform: "capitalize",
                                        borderRadius: "8px",
                                        height: "32px",
                                        px: "21px",
                                        border: "1px solid #E8EAF0",
                                        color: "#2B2B30",
                                        "&:hover": {
                                            backgroundColor: "#614EFA",
                                            color: "#fff"
                                        }
                                    }}>Sign In</Button></Box>
                                </Box>
                            </Box>
                        </Box>
                        <Box>
                            <Box mb="20px">
                                <Typography color="#333333" fontSize="18px" fontWeight="500" mb="4px">Two Factor Authentication</Typography>
                                <Typography color="#333333" fontSize="14px">We recommend requiring a verification code in addition to your password</Typography>
                            </Box>
                            <Box maxWidth="840px" padding="20px 30px" bgcolor="#FFFFFF" borderRadius="12px">
                                <Box
                                    display="flex"
                                    justifyContent={{ xs: "center", sm: "space-between" }}
                                    alignItems={{ xs: "center", sm: "unset" }}
                                    textAlign={{ xs: "center", sm: "unset" }}
                                    flexWrap={{ xs: "wrap", sm: "unset" }}
                                >
                                    <Box width={{ xs: "100%", sm: "70%" }} order={{ xs: "2", sm: "unset" }}>
                                        <Typography color="#333333" fontSize="14px" mb="30px">
                                            Get verification codes from an authenticator app such as Google
                                            Authenticator, It works even if your phone is offline. Scan the QR
                                            code.
                                        </Typography>

                                        <Box>
                                            {!isEnabled && (
                                                <Typography mb="12px" color="#333333" fontSize="14px">
                                                    Enter the 6 Digit verification code generated by your authenticator
                                                    App
                                                </Typography>
                                            )}
                                            <Box
                                                display="flex"
                                                justifyContent={{ xs: "center", sm: "space-between" }}
                                                flexWrap="wrap"
                                                gap={{ xs: "20px", sm: "unset" }}
                                            >
                                                {isEnabled ? (
                                                    <>
                                                        <TextField
                                                            variant="outlined"
                                                            value="Code Verified!"
                                                            sx={{
                                                                maxWidth: { xs: "100%", sm: "calc(100% - 136px)" },
                                                                marginRight: { xs: "0", sm: "14px", md: "30" },
                                                                "& .MuiOutlinedInput-root": {
                                                                    borderRadius: "8px",
                                                                    borderColor: "#C7C7C7",
                                                                },
                                                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                    borderColor: "#333333",
                                                                    border: "1px solid",
                                                                },
                                                                "& .MuiOutlinedInput-input": {
                                                                    padding: "14px 16px",
                                                                    background: "#ffffff",
                                                                    borderRadius: "8px",
                                                                    color: "#22B060",
                                                                    WebkitTextFillColor: "#22B060",
                                                                },
                                                            }}
                                                            fullWidth
                                                            disabled
                                                        />
                                                        <Button
                                                            variant="contained"
                                                            onClick={handleDisableTFA}
                                                            disableElevation
                                                            sx={{
                                                                borderRadius: "8px",
                                                                height: "52px",
                                                                textTransform: "capitalize",
                                                                bgcolor: "#E44258 !important",
                                                                marginRight: { xs: "0", sm: "14px", md: "0" },
                                                            }}
                                                        >
                                                            Disable TFA
                                                        </Button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <TextField
                                                            variant="outlined"
                                                            placeholder="Enter Verification Code"
                                                            sx={{
                                                                maxWidth: { xs: "100%", sm: "calc(100% - 136px)" },
                                                                marginRight: { xs: "0", sm: "14px", md: "30" },
                                                                "& .MuiOutlinedInput-root": {
                                                                    borderRadius: "8px",
                                                                    borderColor: "#C7C7C7",
                                                                },
                                                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                    borderColor: "#333333",
                                                                    border: "1px solid",
                                                                },
                                                                "& .MuiOutlinedInput-input": {
                                                                    padding: "14px 16px",
                                                                    background: "#ffffff",
                                                                    borderRadius: "8px",
                                                                },
                                                                "&.MuiInputBase-input::placeholder": {
                                                                    color: "#333333",
                                                                    fontSize: "16px",
                                                                    opacity: "0.8",
                                                                },
                                                            }}
                                                            fullWidth
                                                        />
                                                        <Button
                                                            variant="contained"
                                                            onClick={handleEnableTFA}
                                                            disableElevation
                                                            sx={{
                                                                borderRadius: "8px",
                                                                height: "52px",
                                                                textTransform: "capitalize",
                                                                marginRight: { xs: "0", sm: "14px", md: "0" },
                                                            }}
                                                        >
                                                            Enable TFA
                                                        </Button>
                                                    </>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>

                                    {!isEnabled && (
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            m="40px 0"
                                            border="1px solid #E8EAF0"
                                            borderRadius="4px"
                                            p="8px"
                                        >
                                            <img src={scannerImg} alt="Scanner" />
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                    <Typography variant="body2" color="#333333" mb="20px" maxWidth="530px" lineHeight="171%">Change Domain name for respective products</Typography>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 4 }} mt={{ xs: 3, lg: '0' }}>
                        <Box maxWidth={"400px"}>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12 }}>
                                    <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Easywebinar</Typography>
                                    <Box display="flex" alignItems="center">
                                        <TextField
                                            variant="outlined"
                                            placeholder='https://StarfieldCorps.easywebinar.live'
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: '8px',
                                                    borderColor: '#C7C7C7',
                                                },

                                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: '#333333',
                                                    border: '1px solid'
                                                },

                                                "& .MuiOutlinedInput-input": {
                                                    padding: '14px 16px',
                                                    background: '#ffffff',
                                                    borderRadius: '8px'
                                                },
                                                "&.MuiInputBase-input::placeholder": {
                                                    color: '#333333',
                                                    fontSize: '16px',
                                                    opacity: '0.8'
                                                },
                                            }}
                                            fullWidth
                                        />
                                        <Box ml="12px" sx={{ cursor: 'pointer' }} onClick={handleDialogOpen}><EditIcon></EditIcon></Box>
                                        <EditIconModal
                                            open={dialogOpen}
                                            onClose={handleDialogClose}
                                            title="Dialog Title"
                                            content="This is the dialog content."
                                            onConfirm={handleConfirm}
                                        />
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>EasyCRM</Typography>
                                    <Box display="flex" alignItems="center">
                                        <TextField
                                            variant="outlined"
                                            placeholder='https://StarfieldCorps.easywebinar.live'
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: '8px',
                                                    borderColor: '#C7C7C7',
                                                },

                                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: '#333333',
                                                    border: '1px solid'
                                                },

                                                "& .MuiOutlinedInput-input": {
                                                    padding: '14px 16px',
                                                    background: '#ffffff',
                                                    borderRadius: '8px'
                                                },
                                                "&.MuiInputBase-input::placeholder": {
                                                    color: '#333333',
                                                    fontSize: '16px',
                                                    opacity: '0.8'
                                                },
                                            }}
                                            fullWidth
                                        />
                                        <Box ml="12px" sx={{ cursor: 'pointer' }} onClick={handleDialogOpen}><EditIcon></EditIcon></Box>
                                        <EditIconModal
                                            open={dialogOpen}
                                            onClose={handleDialogClose}
                                            title="Dialog Title"
                                            content="This is the dialog content."
                                            onConfirm={handleConfirm}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Button sx={{
                            textTransform: 'capitalize', bgcolor: '#614EFA', color: '#FFFFFF !important', px: '24px', height: '52px', fontSize: "16px", borderRadius: '8px', '&:hover': {
                                border: 'none !important',
                                bgcolor: '#331bf1'
                            }, marginTop: "32px", paddingX: "64px"
                        }}
                        >Update</Button>
                    </Grid>
                </CustomTabPanel>
            </Box >
        </Box >
    );
};

export default Settings;
